import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { accountDeletionAPI } from '../services/api';

const inputStyle = {
  width: '100%',
  padding: '0.7rem 0.9rem',
  borderRadius: '8px',
  border: '1px solid #e2e8f0',
  fontSize: '0.95rem',
  marginBottom: '1rem',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
};

const labelStyle = { display: 'block', fontWeight: '600', color: '#2d3748', marginBottom: '0.4rem', fontSize: '0.9rem' };

const buttonStyle = {
  backgroundColor: '#c53030',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  padding: '0.8rem 1.5rem',
  fontSize: '0.95rem',
  fontWeight: '700',
  cursor: 'pointer',
};

const DeleteAccountForm = ({ copy }) => {
  const [identifier, setIdentifier] = useState('');
  const [reason, setReason] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | done | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) return;
    setStatus('submitting');
    try {
      await accountDeletionAPI.submit({ identifier: identifier.trim(), reason: reason.trim() });
      setStatus('done');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'done') {
    return (
      <div style={{ backgroundColor: '#f0fff4', border: '1px solid #9ae6b4', borderRadius: '10px', padding: '1.25rem 1.5rem', color: '#276749' }}>
        {copy.success}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <label style={labelStyle}>{copy.identifierLabel}</label>
      <input
        type="text"
        value={identifier}
        onChange={(e) => setIdentifier(e.target.value)}
        placeholder={copy.identifierPlaceholder}
        required
        style={inputStyle}
      />
      <label style={labelStyle}>{copy.reasonLabel}</label>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={copy.reasonPlaceholder}
        rows={4}
        style={{ ...inputStyle, resize: 'vertical' }}
      />
      <button type="submit" disabled={status === 'submitting'} style={{ ...buttonStyle, opacity: status === 'submitting' ? 0.6 : 1 }}>
        {status === 'submitting' ? copy.submitting : copy.submit}
      </button>
      {status === 'error' && (
        <p style={{ color: '#c53030', marginTop: '0.75rem', fontSize: '0.9rem' }}>{copy.error}</p>
      )}
    </form>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '1.5rem' }}>
    <h2 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.6rem' }}>{title}</h2>
    <div style={{ color: '#4a5568', lineHeight: '1.8', fontSize: '0.97rem' }}>{children}</div>
  </div>
);

const DeleteAccountUz = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Бош саҳифа</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Ҳисобни ва маълумотларни ўчириш</h1>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '1.5rem' }}>
      Агар сиз AdvokatTop'даги ҳисобингизни ва унга тегишли барча шахсий маълумотларни (профил, юборилган сўровлар, хабарлар, тўлов тарихи ва бошқалар) ўчиришни хоҳласангиз, қуйидаги шаклни тўлдиринг. Сўровингиз қабул қилингач, <strong>Маҳфийлик сиёсатимизга</strong> мувофиқ ҳисобингиз ва маълумотларингиз <strong>30 кун ичида</strong> қўлда текширилиб, тизимдан батамом ўчирилади.
    </p>
    <Section title="Шаклни тўлдиринг">
      <DeleteAccountForm
        copy={{
          identifierLabel: 'Ҳисобингизга боғланган email ёки телефон рақами',
          identifierPlaceholder: 'email@masalan.com ёки +998901234567',
          reasonLabel: 'Сабаб (ихтиёрий)',
          reasonPlaceholder: 'Нима учун ҳисобингизни ўчирмоқчисиз?',
          submit: 'Ўчиришни сўраш',
          submitting: 'Юборилмоқда...',
          success: 'Сўровингиз қабул қилинди. Ҳисобингиз ва маълумотларингиз 30 кун ичида ўчирилади. Савол бўлса: alis.ergashev@gmail.com',
          error: 'Хатолик юз берди. Илтимос, қайта уриниб кўринг ёки alis.ergashev@gmail.com манзилига ёзинг.',
        }}
      />
    </Section>
    <Section title="Муқобил йўл">
      <p>Шунингдек, сўровингизни тўғридан-тўғри <strong>alis.ergashev@gmail.com</strong> манзилига юборишингиз мумкин.</p>
    </Section>
  </>
);

const DeleteAccountRu = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Главная</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Удаление аккаунта и данных</h1>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '1.5rem' }}>
      Если вы хотите удалить свой аккаунт на AdvokatTop и все связанные с ним персональные данные (профиль, отправленные запросы, сообщения, история платежей и т.д.), заполните форму ниже. После получения запроса, в соответствии с нашей <strong>Политикой конфиденциальности</strong>, ваш аккаунт и данные будут проверены и полностью удалены из системы в течение <strong>30 дней</strong>.
    </p>
    <Section title="Заполните форму">
      <DeleteAccountForm
        copy={{
          identifierLabel: 'Email или номер телефона, привязанный к аккаунту',
          identifierPlaceholder: 'email@example.com или +998901234567',
          reasonLabel: 'Причина (необязательно)',
          reasonPlaceholder: 'Почему вы хотите удалить свой аккаунт?',
          submit: 'Запросить удаление',
          submitting: 'Отправка...',
          success: 'Ваш запрос принят. Аккаунт и данные будут удалены в течение 30 дней. Если у вас есть вопросы: alis.ergashev@gmail.com',
          error: 'Произошла ошибка. Попробуйте ещё раз или напишите на alis.ergashev@gmail.com.',
        }}
      />
    </Section>
    <Section title="Альтернативный способ">
      <p>Вы также можете отправить запрос напрямую на <strong>alis.ergashev@gmail.com</strong>.</p>
    </Section>
  </>
);

const DeleteAccountRequest = () => {
  const { language } = useLanguage();
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem' }}>
        {language === 'ru' ? <DeleteAccountRu /> : <DeleteAccountUz />}
      </div>
    </div>
  );
};

export default DeleteAccountRequest;
